var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showPop,
          expression: "showPop"
        }
      ],
      attrs: { value: _vm.value }
    },
    [
      _c(
        "van-dialog",
        {
          attrs: { "show-cancel-button": "", confirmButtonText: "保存" },
          on: { confirm: _vm.add },
          model: {
            value: _vm.showPop,
            callback: function($$v) {
              _vm.showPop = $$v
            },
            expression: "showPop"
          }
        },
        [
          _c(
            "van-cell-group",
            [
              _c(
                "van-cell",
                {
                  attrs: { title: "产品分类" },
                  on: {
                    click: function($event) {
                      _vm.showType = !_vm.showType
                    }
                  }
                },
                [
                  _vm.obj.U_ProductClass1
                    ? _c("p", { staticClass: "item2 date-time black" }, [
                        _vm._v(_vm._s(_vm.obj.U_ProductClass1))
                      ])
                    : _c("p", { staticClass: "item2 date-time" }, [
                        _vm._v("选择产品一级分类")
                      ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "triangle_border_down",
                    attrs: { slot: "right-icon" },
                    slot: "right-icon"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "van-cell",
                { attrs: { title: "名称" } },
                [
                  _c("van-field", {
                    staticClass: "item2",
                    attrs: { placeholder: "请输入名称" },
                    on: {
                      input: function($event) {
                        return _vm.limitLength(100, "obj", "U_ProductName")
                      }
                    },
                    model: {
                      value: _vm.obj.U_ProductName,
                      callback: function($$v) {
                        _vm.$set(_vm.obj, "U_ProductName", $$v)
                      },
                      expression: "obj.U_ProductName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-cell",
                { attrs: { title: "金额" } },
                [
                  _c("van-field", {
                    staticClass: "item2",
                    attrs: { type: "number", placeholder: "请输入金额" },
                    model: {
                      value: _vm.obj.U_Amount,
                      callback: function($$v) {
                        _vm.$set(_vm.obj, "U_Amount", $$v)
                      },
                      expression: "obj.U_Amount"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showType,
            callback: function($$v) {
              _vm.showType = $$v
            },
            expression: "showType"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              columns: _vm.pickerList,
              "value-key": "name"
            },
            on: {
              confirm: _vm.typeChange,
              cancel: function($event) {
                _vm.showType = !_vm.showType
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c691840", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c691840","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/component/salesPop.vue
// module id = null
// module chunks = 